<template>
<!--  <ReloadPWA />-->
  <event-keeper />
      <router-view />
  <modal-keeper />
</template>

<script setup>
import { ref, onMounted } from "vue";
import { RouterView } from "vue-router";
import { useWindowSize, watchDebounced } from "@vueuse/core";
import ModalKeeper from "@/components/modals/ModalKeeper.vue";
import EventKeeper from "@/components/events/EventKeeper.vue";
import ReloadPWA from "@/components/blocks/PWAReload.vue";

// import myServiceWorker from "@/"

const { width, height } = useWindowSize()

const _prev_width = ref(width)

function setAppHeight(height = window.innerHeight) {
  const doc = document.documentElement
  doc.style.setProperty('--app-height', `${height}px`)
}

onMounted(() => {
  setAppHeight()
})

watchDebounced(height, () => {
  if (width.value !== _prev_width) {
    setAppHeight()
  } else {

    if (width.value >= 1024 && height.value >= 801) {
      setAppHeight()
    }
  }
}, { debounce: 200, maxWait: 5000})
</script>

<style lang="scss">
body {
  scroll-behavior: smooth;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: var(--border-color);
  }
}
</style>